import { AllTypesOfLeavesResponseModel, TypesOfLeavesResponseModel } from '@gtpl/shared-models/hrms';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Controller, Post, Body, Req, All } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { TypesOfLeavesDTO } from './dto/types-of-leaves.dto';
import { TypeOfLeaveRequest } from './dto/types-of-leaves.request';
import { TypesOfLeavesService } from './types-of-leaves.service';

@ApiTags('types-of-leaves')
@Controller('types-of-leaves')
export class TypesOfLeavesController {

    constructor(
        private service: TypesOfLeavesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createTypesOfLeaves')
    async createTypesOfLeaves(@Body() DTO: TypesOfLeavesDTO, isUpdate: boolean = false): Promise<TypesOfLeavesResponseModel>{
        try{
            return await this.service.createTypesOfLeaves(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TypesOfLeavesResponseModel, error);
        }
    }

    @Post('/updateTypesOfLeaves')
    async updateTypesOfLeaves(@Body() DTO: TypesOfLeavesDTO, isUpdate: boolean = false): Promise<TypesOfLeavesResponseModel>{
        try{
            return await this.service.createTypesOfLeaves(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TypesOfLeavesResponseModel, error);
        }
    }

    @Post('/getAllTypesOfLeaves')
    async getAllTypesOfLeaves(): Promise<AllTypesOfLeavesResponseModel>{
        try{
            return await this.service.getAllTypesOfLeaves();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllTypesOfLeavesResponseModel, error);
        }
    }

    @Post('/getAllActiveTypesOfLeaves')
    async getAllActiveTypesOfLeaves(): Promise<AllTypesOfLeavesResponseModel>{
        try{
            return await this.service.getAllActiveTypesOfLeaves();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllTypesOfLeavesResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateTypesOfLeave')
    async activateOrDeactivateTypesOfLeave(@Body() TypesOfLeavesReq: TypeOfLeaveRequest): Promise<TypesOfLeavesResponseModel>{
        try{
            return await this.service.activateOrDeactivateTypesOfLeave(TypesOfLeavesReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TypesOfLeavesResponseModel, error);
        }
    }
}
